import { render, staticRenderFns } from "./DownLoadSelection.vue?vue&type=template&id=32242463&scoped=true&"
import script from "./DownLoadSelection.vue?vue&type=script&lang=js&"
export * from "./DownLoadSelection.vue?vue&type=script&lang=js&"
import style0 from "./DownLoadSelection.vue?vue&type=style&index=0&id=32242463&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32242463",
  null
  
)

export default component.exports